import React, { ErrorInfo, FC } from 'react';
import { IonPage } from '@ionic/react';
import { Container_v2 as Container, ErrorCardFeature } from '@mindly/ui-components';
import { useTranslation } from 'react-i18next';

type CrashScreenProps = {
  error?: Error;
  errorInfo?: ErrorInfo;
};

const CrashScreen: FC<CrashScreenProps> = ({ error, errorInfo }) => {
  const { t } = useTranslation('app');

  return (
    <IonPage>
      <Container>
        <ErrorCardFeature
          title={t('error_screen.title')}
          errorTitle={error && error.toString()}
          stackTrace={errorInfo?.componentStack ?? ''}
        />
      </Container>
    </IonPage>
  );
};

export default CrashScreen;
